import { render, staticRenderFns } from "./UserSelectA.vue?vue&type=template&id=0b7997ea"
import script from "./UserSelectA.vue?vue&type=script&lang=js"
export * from "./UserSelectA.vue?vue&type=script&lang=js"
import style0 from "./UserSelectA.vue?vue&type=style&index=0&id=0b7997ea&prod&lang=less"
import style1 from "./UserSelectA.vue?vue&type=style&index=1&id=0b7997ea&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports